import DocumentServiceModel from "../DocumentServiceModel";

export default class Document extends DocumentServiceModel {
  modelName() {
    return "documents";
  }
  defaults() {
    return {
      id: null,
      user_id: null,
      user: null,
      name: null,
      ext: null,
      mime_type: null,
      size: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      user_id: val => this.nullStringMutator(val),
      name: val => this.nullStringMutator(val),
      ext: val => this.nullStringMutator(val),
      mime_type: val => this.nullStringMutator(val),
      size: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
  routes() {
    const base = `${process.env.VUE_APP_DOCUMENT_REPOSITORY_URL}/api/v1/`;
    const routes = super.routes();

    routes.file = `${base}${this.modelName()}/{document_id}/file`;

    return routes;
  }
  file() {
    const config = {
      method: this.getMethod("fetch"),
      url: this.getURL(this.getRoute("file"), { document_id: this.id }),
      data: {}
    };

    if (this.mime_type === "application/pdf") {
      config.responseType = "arraybuffer";
    }

    return this.createRequest(config).send();
  }
}
